import { Injectable } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";
import {
  Router,
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from "@angular/router";
import { Observable, of } from "rxjs";
import { SeoService } from "src/app/services/seo.service";

@Injectable({
  providedIn: "root",
})
export class ContactResolver implements Resolve<boolean> {
  constructor(
    private meta: Meta, // private socialService: SocialService,
    private title: Title,
    public router: Router,
    private seo: SeoService
  ) { }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    this.populateMetaTags([0], route);
    return of(true);
  }

  populateMetaTags(data, route) {
    //console.log(route.paramMap);
    const title = "Contact Us | Illusbook";
    const desc =
      "Get in touch with the Illusbook team for support, inquiries, or feedback. We're here to help and typically respond within a few hours.";
    const image = "assets/img/illusbook.png";
    //console.log("Router URL:", this.router);
    // const protocol =
    //   this.request.headers["x-forwarded-proto"] || this.request.protocol;
    // const host = this.request.headers.host;
    // const originalUrl = this.request.originalUrl;
    // const fullURL = `${protocol}://${host}${originalUrl}`;
    const fullURL = `https://illusbook.com/contact`;
    //console.log("Window URL:", fullURL);
    this.title.setTitle(`${title}`);
    this.setMetaTag("name", "title", title);
    this.setMetaTag("name", "description", desc);
    this.setMetaTag("name", "og:description", desc);
    this.setMetaTag("name", "og:title", title);
    this.setMetaTag("property", "og:title", title);
    this.setMetaTag("property", "og:description", desc);
    this.setMetaTag("property", "og:image", image);
    this.setMetaTag("property", "og:url", fullURL);
    this.setMetaTag("property", "og:type", "article");
    this.setMetaTag("property", "og:site_name", "Illusbook");
    this.setMetaTag("property", "twitter:card", "summary_large_image");

    const ORGANIZATION_SCHEMA = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "@id": "https://illusbook.com/#organization",
      "name": "Illusbook",
      "url": "https://illusbook.com",
      "logo": "https://illusbook.com/assets/favicon/android-icon-192x192.png",
      "description": "Illusbook offers a collection of stunning illustrations. Browse and download the perfect illustrations for your projects today.",
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "Customer Support",
        "email": "support@illusbook.com",
        "availableLanguage": ["English"]
      },
      "sameAs": [
        "https://www.linkedin.com/company/illusbook/",
        "https://www.instagram.com/illusbook/",
        "https://x.com/illusbook",
        "https://www.pinterest.com/illusbook/"
      ]
    };

    this.seo.setJSONLD([
      {
        "@context": "https://schema.org",
        "@type": "ContactPage",
        "name": title,
        "description": desc,
        "url": fullURL,
        "inLanguage": "en",
        "mainEntityOfPage": fullURL,
        "isPartOf": { "@type": "WebSite", "name": "Illusbook", "url": "https://illusbook.com" },
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://illusbook.com" },
            { "@type": "ListItem", "position": 2, "name": "Contact", "item": fullURL }
          ]
        },
        "publisher": { "@id": "https://illusbook.com/#organization" }
      },
      ORGANIZATION_SCHEMA
    ]);

  }

  setMetaTag(
    attrName: "name" | "property",
    attrValue: string,
    content: string
  ) {
    const selector = `${attrName}="${attrValue}"`;
    //console.log(selector);
    this.meta.removeTag(selector);
    this.meta.addTag({ [attrName]: attrValue, content });
    // this.meta.updateTag({ [attrName]: attrValue, content });
  }
}
